// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__rtFIf","footer":"ModalCreateQualiphyProcedure_footer__1zmDj","additionData":"ModalCreateQualiphyProcedure_additionData__3KyGZ"};